import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900">
      <div className="w-full px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <h4 className="font-heading text-xl text-background-50 mb-4">
              <a href="/" className="cursor-pointer">虫虫漫画</a>
            </h4>
            <p className="text-sm text-background-400 leading-relaxed">
              虫虫漫画大全汇集全集免费漫画，好看的韩漫日漫国漫分类推荐，支持下拉式在线阅读，追更收藏尽在虫虫漫画平台。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">快速导航</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">首页</Link></li>
              <li><Link to="/category/hanman" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">韩漫专区</Link></li>
              <li><Link to="/category/riman" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">日漫专区</Link></li>
              <li><Link to="/category/guoman" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">国漫专区</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">热门推荐</h4>
            <ul className="space-y-2">
              <li><Link to="/comic/comic-003" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">樱花庄的日常</Link></li>
              <li><Link to="/comic/comic-012" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">游戏人生</Link></li>
              <li><Link to="/comic/comic-002" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">星域猎手</Link></li>
              <li><Link to="/comic/comic-007" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">狐妖小红娘</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 whitespace-nowrap">关于我们</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">品牌介绍</Link></li>
              <li><Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors cursor-pointer whitespace-nowrap">联系我们</Link></li>
            </ul>
            <div className="flex items-center gap-3 mt-4">
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 flex items-center justify-center rounded-full bg-background-700 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors cursor-pointer" rel="nofollow">
                <i className="ri-bilibili-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-background-700 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; 2026 虫虫漫画 版权所有 | 虫虫漫画大全 - 虫虫漫画全集免费在线看
          </p>
          <p className="text-xs text-background-500">
            好看的漫画下拉式阅读 | 韩漫日漫国漫尽在虫虫漫画
          </p>
        </div>
      </div>
    </footer>
  );
}